import {
  Search as SearchIcon,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useGetAccountByUserEmail } from '../../hooks/query/useAccounts';
import { AccountInfo } from './AccountInfo/AccountInfo';
import { NoAccountFound } from './NoAccountFound/NoAccountFound';

export const SearchAccountPage = (): JSX.Element => {
  const [searchQuery, setSearchQuery] = useState<string>(null);

  const {
    data: account,
    isLoading,
    isFetching,
    isError,
    refetch: getAccountByUserEmail,
  } = useGetAccountByUserEmail(searchQuery);

  const renderSearchResult = (): JSX.Element => {
    if (isLoading) {
      return (
        <Box sx={ { display: 'flex', justifyContent: 'center' } }>
          <CircularProgress size="50px" />
        </Box>
      );
    }

    if (account) {
      return <AccountInfo account={ account } userEmail={ searchQuery } />;
    }

    return <NoAccountFound userEmail={ searchQuery } />;
  };

  return (
    <Container maxWidth="md" sx={ { paddingBlock: '20px' } }>
      <Stack
        direction="row"
        alignItems="center"
        spacing={ 1 }
        sx={ { paddingBlock: '24px' } }
      >
        <SearchIcon fontSize="large" />

        <Typography variant="h3">Search Account</Typography>
      </Stack>

      <Card>
        <Stack alignContent="center">
          <Stack
            spacing={ 2 }
            direction="row"
            justifyContent="center"
            sx={ { paddingBlock: '20px' } }
          >
            <TextField
              variant="outlined"
              placeholder="Enter a user's email"
              sx={ { width: '300px' } }
              value={ searchQuery }
              onChange={ (e) => setSearchQuery(e.target.value) }
              onKeyPress={ (e) => {
                if (e.key === 'Enter') {
                  getAccountByUserEmail();
                }
              } }
            />

            <Button
              title="Search"
              variant="contained"
              startIcon={ <SearchIcon /> }
              onClick={ () => getAccountByUserEmail() }
              disabled={ isFetching || !searchQuery?.length }
            >
              Search
            </Button>
          </Stack>

          {(account || isLoading || isError) && (
            <>
              <Divider />

              <Stack
                justifyContent="center"
                alignContent="center"
                sx={ { padding: '24px' } }
              >
                {renderSearchResult()}
              </Stack>
            </>
          )}
        </Stack>
      </Card>
    </Container>
  );
};
